import "@fontsource/caprasimo/400.css";
import "@fontsource/figtree/400.css";
import "@fontsource/figtree/600.css";
import "@fontsource/figtree/700.css";
import "./theme";
import "./styles.css";
import { initDayRoutePanel } from "./day-route-panel";
import { initEditDialog } from "./edit-dialog";
import { applyStaticTranslations, i18n } from "./i18n";
import { initMap } from "./map";
import {
  clearHash,
  clearTripParam,
  decodeTripFromHash,
  loadTripFromWorker,
} from "./share-url";
import { savedTrips } from "./saved-trips-store";
import { initSavedTripsDialog } from "./saved-trips-dialog";
import { startShareSync } from "./share-sync";
import { setupShortcuts } from "./shortcuts";
import { initSidebar } from "./sidebar";
import { stops } from "./stops";
import { initSummaryDialog } from "./summary";

async function start(): Promise<void> {
  applyStaticTranslations();
  initMap("map");
  initSidebar();
  initEditDialog();
  initDayRoutePanel();
  initSummaryDialog();
  initSavedTripsDialog();
  setupShortcuts();

  // Mirror the active trip into the local library on every change. Wired before load() so the
  // trip already on disk lands in the library too. No loop: it writes a different key.
  savedTrips.load();
  stops.addEventListener("change", () => savedTrips.upsert(stops.getState()));

  const tripId = new URLSearchParams(location.search).get("trip");
  const shared =
    tripId !== null
      ? await loadTripFromWorker(tripId)
      : await decodeTripFromHash(location.hash);

  // Load the previously-active trip first (it stays preserved in the library), then a shared
  // link or hash trip is added as a *new* library entry rather than overwriting anything.
  stops.load();
  if (shared && shared.stops.length > 0) {
    stops.replaceAll(shared.stops, shared.tripName);
    if (tripId !== null) clearTripParam();
    else clearHash();
  }

  // After the initial load, so a page open can never be mistaken for an edit.
  startShareSync();

  i18n.addEventListener("change", () => applyStaticTranslations());
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    void start();
  });
} else {
  void start();
}
